import { customers } from "../../config/customers";
import { getCustomerKey } from "../../utils/domain";
import { defaultBrand } from "./brand";
import { themePresets } from "./presets";
import type { BrandTokens, ThemePreset } from "./types";

type ThemeConfig = {
  preset?: ThemePreset;
  brand?: Partial<BrandTokens>;
};

const normalizeBrand = (brand?: Partial<BrandTokens>): BrandTokens => ({
  ...defaultBrand,
  ...brand
});

const resolvePreset = (configPreset?: ThemePreset, overridePreset?: ThemePreset) => {
  if (overridePreset && themePresets[overridePreset]) return overridePreset;
  const envPreset = process.env.REACT_APP_THEME_PRESET?.trim() as ThemePreset | undefined;
  if (envPreset && themePresets[envPreset]) return envPreset;
  return configPreset && themePresets[configPreset] ? configPreset : "material";
};

export const getActivePreset = (overridePreset?: ThemePreset) => {
  const key = getCustomerKey();
  const themeConfig = (customers[key].theme || {}) as ThemeConfig;
  return resolvePreset(themeConfig.preset, overridePreset);
};

export const getCustomerTheme = (overridePreset?: ThemePreset) => {
  const key = getCustomerKey();
  const themeConfig = (customers[key].theme || {}) as ThemeConfig;
  const preset = resolvePreset(themeConfig.preset, overridePreset);
  const brand = normalizeBrand(themeConfig.brand);

  return themePresets[preset](brand);
};
